import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";

export async function fetchTripHistory(deviceId, from, to) {
  if (!deviceId || !from || !to) {
    console.error("Device ID, from, and to timestamps are required.");
    return [];
  }

  const fetchTripHistory = httpsCallable(functions, "fetchTripHistory");
  try {
    const result = await fetchTripHistory({ deviceId, from, to });
    console.log("Trip history response:", result.data); // Debug log
    return result.data.result || [];
  } catch (error) {
    console.error("Trip fetch error:", error);
    return [];
  }
}